import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import withLoadingIndicator from './withLoadingIndicator';
import { IconChevron, IconSearch, IconDownloadSquare, IconDownloadSquareSolid } from './index';

var IconBack = function IconBack(props) {
  return React.createElement(IconChevron, _extends({
    direction: "left"
  }, props));
};

var IconSearchAnimated = withLoadingIndicator(IconSearch);

var IconUploadSquare = function IconUploadSquare(props) {
  return React.createElement(IconDownloadSquare, _extends({
    style: {
      transform: 'rotate(180deg)'
    }
  }, props));
};

var IconUploadSquareSolid = function IconUploadSquareSolid(props) {
  return React.createElement(IconDownloadSquareSolid, _extends({
    style: {
      transform: 'rotate(180deg)'
    }
  }, props));
};

export { IconBack, IconSearchAnimated, IconUploadSquare, IconUploadSquareSolid };